import axios from "axios";

export const getCartItemDesign = (id) =>
  new Promise((resolve, reject) => {
    axios
      .get("/wp-json/dpe/v1/design/cartItem", { params: { id } })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((err) => {
        reject(err);
      });
  });

export const updateCartItemDesign = ({ id, canvasData }) =>
  new Promise((resolve, reject) => {
    axios
      .post("/wp-json/dpe/v1/design/cartItem", { id, canvasData })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((err) => {
        reject(err);
      });
  });

export const getSharedDesign = (designId) =>
  new Promise((resolve, reject) => {
    axios
      .get("/wp-json/dpe/v1/design/share", { params: { designId } })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((err) => {
        reject(err);
      });
  });

export const shareDesign = (productId, canvasData, proboOptions) =>
  new Promise((resolve, reject) => {
    axios
      .post("/wp-json/dpe/v1/design/share", {
        productId,
        canvasData,
        proboOptions,
      })
      .then(({ data }) => {
        if (!data.url || !data.thumbnail) {
          reject(new Error("Invalid data format"));
        }
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });

export const getFavoriteDesign = (designId) =>
  new Promise((resolve, reject) => {
    axios
      .get("/wp-json/dpe/v1/design/favorite", { params: { designId } })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((err) => {
        reject(err);
      });
  });

export const updateFavoriteDesign = (
  designId,
  canvasData,
  productId,
  proboCodes
) =>
  new Promise((resolve, reject) => {
    axios
      .post("/wp-json/dpe/v1/design/favorite", {
        designId,
        canvasData,
        productId,
        proboCodes,
      })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((err) => {
        reject(err);
      });
  });

export const getOrderItemDesign = (orderItem) =>
  new Promise((resolve, reject) => {
    axios
      .get("/wp-json/dpe/v1/design/orderItem", { params: { orderItem } })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((err) => {
        reject(err);
      });
  });

export const updateOrderItemDesign = ({
  orderItemId,
  canvasData,
  productId,
  proboOptions,
  orderId,
  width,
  count,
  height,
}) =>
  new Promise((resolve, reject) => {
    axios
      .post("/wp-json/dpe/v1/design/orderItem", {
        orderItemId,
        canvasData,
        productId,
        proboOptions,
        orderId,
        count,
        width,
        height,
      })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
